export default "__VITE_ASSET__ea783389__"